module.exports = __webpack_public_path__ + "media/images/leuva-image-fa7598ee5a5c9e6125638ca3688f802f.jpg";